function parseDate(value?: string): Date | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

function russianDayWord(value: number): string {
  const lastTwo = value % 100;
  if (lastTwo >= 11 && lastTwo <= 14) return "дней";
  const last = value % 10;
  if (last === 1) return "день";
  if (last >= 2 && last <= 4) return "дня";
  return "дней";
}

export function formatTime(value?: string): string {
  const date = parseDate(value);
  return date ? date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" }) : value ?? "";
}

export function formatDate(value?: string): string {
  const date = parseDate(value);
  return date ? date.toLocaleDateString("ru-RU", { day: "numeric", month: "long" }) : value ?? "";
}

export function formatMessageTime(value?: string, now = new Date()): string {
  const date = parseDate(value);
  if (!date) return value ?? "";
  const daysAgo = Math.floor((startOfDay(now) - startOfDay(date)) / 86_400_000);
  if (daysAgo <= 0) return formatTime(value);
  if (daysAgo === 1) return "вчера";
  return `${daysAgo} ${russianDayWord(daysAgo)} назад`;
}

export function formatMessageDay(value?: string, now = new Date()): string {
  const date = parseDate(value);
  if (!date) return value ?? "";
  const daysAgo = Math.floor((startOfDay(now) - startOfDay(date)) / 86_400_000);
  if (daysAgo <= 0) return "Сегодня";
  if (daysAgo === 1) return "Вчера";
  return `${daysAgo} ${russianDayWord(daysAgo)} назад`;
}
